import { withKeycloak } from "@react-keycloak/web";
import React from "react";
import ClassificationService from "../../../../../services/ClassificationService";
import ClassificationTypeService from "../../../../../services/ClassificationTypeService";
import {
  activeFilter,
  selectFilter,
  trueFilter
} from "../../../../../services/FilteringUtils";
import CommonUtil from "../../../../../utils/CommonUtil";
import { constants } from "../../../../../utils/Constants";
import SearchableTreeComponent from "../../../page/SearchableTreeComponent";
import ClassificationSelectionOutput from "./ClassificationSelectionOutput";

class ClassificationSelectionOutputContainer extends SearchableTreeComponent {
  constructor(props) {
    super(props);

    this.classificationTypeService = new ClassificationTypeService(
      this.keycloak
    );
    this.classificationService = new ClassificationService(this.keycloak);
    this.state = {
      ...this.state,
      classificationsPageInfo: {
        filters: {
          ...activeFilter,
          fetchParents: trueFilter,
          fetchChildren: trueFilter
        }
      }
    };
  }

  initialPageInfo() {
    var pageInfo = super.initialPageInfo();
    pageInfo.filters = {
      ...pageInfo.filters,
      classificationActive: trueFilter
    };
    return pageInfo;
  }

  componentDidUpdate() {
    super.componentDidUpdate();

    if (
      this.props.selectedClassifications !== this.state.selectedClassifications
    ) {
      this.setState(
        { selectedClassifications: this.props.selectedClassifications },
        () => this.loadRoots(this.state.pageInfo)
      );
    }
  }

  createTableIdFilters = (entities, comparator) => {
    let ids = entities;
    if (ids.length === 0) {
      ids = [-1];
    }
    return selectFilter(ids, comparator);
  };

  addPredefinedIdsFilter(
    pageInfo,
    predefined,
    filterName = "id",
    comparator = "IN"
  ) {
    pageInfo = {
      ...pageInfo,
      filters: {
        ...pageInfo.filters,
        [filterName]: this.createTableIdFilters(predefined, comparator)
      }
    };
    return pageInfo;
  }

  loadRoots = pageInfo => {
    if (
      this.state.selectedClassifications &&
      this.state.selectedClassifications.length
    ) {
      this.prepareCall(
        this.classificationTypeService.getEntities(
          this.getClassificationLoadPageInfo(pageInfo, "classificationId"),
          this.sortInfo,
          this.onRootDataLoad,
          this.messageHandler.handleError
        )
      );
      this.performCalls();
    } else {
      this.setState({ content: [] });
    }
  };

  onRootDataLoad = data => {
    const pageInfo = {
      ...data.page,
      filters: this.state.pageInfo.filters
    };
    if (data._embedded) {
      const content = data._embedded.content.map(item => {
        return {
          ...item,
          key: constants.TYPE_PREFIX + item.id,
          disabled: true
        };
      });

      this.setState({
        loadedKeys: [],
        content: content,
        links: data._links,
        pageInfo: pageInfo
      });
    }
  };

  getClassificationLoadPageInfo = (pageInfo, filterName = "id") => {
    return this.addPredefinedIdsFilter(
      pageInfo,
      this.state.selectedClassifications,
      filterName
    );
  };

  loadDataByType = type => {
    this.prepareCall(
      this.classificationService.getClassificationsByType(
        type,
        this.onTypeDataLoad,
        this.messageHandler.handleError,
        this.getClassificationLoadPageInfo(this.state.classificationsPageInfo)
      )
    );
    return this.performCalls();
  };

  onTypeDataLoad = data => {
    const treeNodeData = this.state.content.find(
      item =>
        "" + item.id ===
        CommonUtil.queryParamsGetValueForKey(
          constants.CLASSIFICATION_TYPE_ID,
          data._links.self.href
        )
    );

    if (!treeNodeData) return;

    this.state.loadedKeys.push(treeNodeData.key);
    if (data._embedded) {
      const children = data._embedded.content.map(item => {
        return {
          ...item,
          key: "" + item.id,
          disabled: false
        };
      });
      treeNodeData.children = children;
    } else {
      treeNodeData.children = undefined;
      treeNodeData.leaf = true;
    }
    this.setState({
      loadedKeys: this.state.loadedKeys,
      content: [...this.state.content]
    });
  };

  loadDataByParent = parent => {
    this.prepareCall(
      this.classificationService.getClassificationsChildren(
        parent,
        this.onDataLoad,
        this.messageHandler.handleError,
        this.getClassificationLoadPageInfo(this.state.classificationsPageInfo)
      )
    );
    return this.performCalls();
  };

  loadData = (expanded, onLoadCallback) => {
    if (expanded.disabled) {
      return this.loadDataByType(expanded);
    } else {
      return this.loadDataByParent(expanded, onLoadCallback);
    }
  };

  checkNodeCallback = (item, data) => {
    return (
      !item.key.startsWith(constants.TYPE_PREFIX) &&
      "" + item.id ===
        CommonUtil.queryParamsGetValueForKey(
          constants.CLASSIFICATION_PARENT_ID,
          data._links.self.href
        )
    );
  };

  loadEntitiesWithFilter = pageInfo => {
    this.loadClassificationsWithFilter(
      this.getClassificationLoadPageInfo(pageInfo)
    );
  };

  loadClassificationsWithFilter = pageInfo => {
    this.prepareCall(
      this.classificationService.getEntities(
        pageInfo,
        this.sortInfo,
        this.onLoadWithFilter,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onLoadWithFilter = data => {
    const pageInfo = data.page;
    pageInfo.filters = this.state.pageInfo.filters;
    let content = [];
    const dataContent = CommonUtil.getDataContent(data);
    if (dataContent) {
      content = dataContent.map(item => {
        return {
          ...item,
          key: "" + item.id,
          selectable: this.props.classificationsFilter
            ? this.props.classificationsFilter.includes(item.id)
            : true,
          leaf: true
        };
      });
    }
    this.setState({
      loadedKeys: [],
      content: content,
      links: data._links,
      pageInfo: pageInfo
    });
  };

  render() {
    return <ClassificationSelectionOutput {...this.renderProps()} />;
  }
}

export default withKeycloak(ClassificationSelectionOutputContainer);
